module.exports = __webpack_public_path__ + "img/hire3x-container-icon.a1dbff88.svg";